import { useState } from 'react';

interface Props {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  autoComplete: 'current-password' | 'new-password';
  placeholder?: string;
  minLength?: number;
  /** Текст ошибки под полем — например, о несовпадении паролей. */
  error?: string | null;
}

/**
 * Поле пароля со значком показа.
 *
 * Показ введённого нужен не для удобства, а чтобы не создать пароль
 * с опечаткой: восстановления пароля в системе пока нет, и цена ошибки
 * при регистрации — потерянная учётная запись.
 */
export function PasswordField({
  id, label, value, onChange, autoComplete, placeholder, minLength, error,
}: Props) {
  const [visible, setVisible] = useState(false);

  return (
    <div className="field">
      <label htmlFor={id}>{label}</label>
      <div className="password-row">
        <input
          id={id}
          type={visible ? 'text' : 'password'}
          value={value}
          onChange={(event) => onChange(event.target.value)}
          autoComplete={autoComplete}
          placeholder={placeholder}
          minLength={minLength}
          required
          // При показанном пароле клавиатура иначе подставит своё
          autoCapitalize="none"
          autoCorrect="off"
          spellCheck={false}
        />
        <button
          type="button"
          className="icon-button password-toggle"
          onClick={() => setVisible((shown) => !shown)}
          title={visible ? 'Скрыть пароль' : 'Показать пароль'}
          aria-label={visible ? 'Скрыть пароль' : 'Показать пароль'}
          aria-pressed={visible}
          // Кнопка не должна забирать фокус: иначе на телефоне
          // закрывается клавиатура и приходится тыкать в поле заново
          tabIndex={-1}
        >
          <EyeIcon crossed={visible} />
        </button>
      </div>
      {error && <p className="field-error">{error}</p>}
    </div>
  );
}

function EyeIcon({ crossed }: { crossed: boolean }) {
  return (
    <svg
      viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"
      fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"
    >
      <path d="M2 12s3.6-6 10-6 10 6 10 6-3.6 6-10 6-10-6-10-6Z" />
      <circle cx="12" cy="12" r="2.6" />
      {crossed && <path d="M4 20 20 4" />}
    </svg>
  );
}
